import script from "./StreamThumbnail.vue?vue&type=script&setup=true&lang=js"
export * from "./StreamThumbnail.vue?vue&type=script&setup=true&lang=js"

import "./StreamThumbnail.vue?vue&type=style&index=0&id=6c8ff4b0&lang=css"

const __exports__ = script;

export default __exports__